import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* © 2023 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { createTheme } from '@mui/material/styles';
import { PROMETHEAN_HEAVY_SHADOW, PROMETHEAN_MEDIUM_SHADOW } from '../styles/elevation/elevation';
import { PROMETHEAN_TYPOGRAPHY_BODY, PROMETHEAN_TYPOGRAPHY_SMALL_TEXT_UPPERCASE, PROMETHEAN_TYPOGRAPHY_SUBTITLE_04 } from '../styles/typography/typography';
import { PROMETHEAN_NEUTRAL_DARK_GREY, PROMETHEAN_PURPLE_PLUM, PROMETHEAN_TEXT, PROMETHEAN_TEXT_HEADER, PROMETHEAN_NEUTRAL_DARK_PLUM, PROMETHEAN_BLUE } from '../styles/colors/colors';
export var EMBERS_CARD_ROOT_PREFIX = 'EmbersCard';
export var createEmbersCardTheme = function createEmbersCardTheme(contentPadding, headerPadding, hasHeader) {
  var _header, _objectSpread2;
  return createTheme({
    components: {
      MuiCard: {
        styleOverrides: {
          root: _objectSpread(_objectSpread({}, PROMETHEAN_MEDIUM_SHADOW), {}, (_objectSpread2 = {
            borderRadius: 8,
            margin: 0
          }, _defineProperty(_objectSpread2, "&.".concat(EMBERS_CARD_ROOT_PREFIX, "-clickable"), {
            cursor: 'pointer',
            '&:focus-visible': {
              boxShadow: "rgba(0, 0, 0, 0.25) 0px 4px 8px, 0 0 0 2px ".concat(PROMETHEAN_BLUE)
            },
            '&:hover': _objectSpread({}, PROMETHEAN_HEAVY_SHADOW)
          }), _defineProperty(_objectSpread2, '.card-icon', {
            color: PROMETHEAN_TEXT,
            position: 'absolute',
            width: 40,
            height: 40,
            right: -8,
            top: -8,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }), _defineProperty(_objectSpread2, '.card-icon:not(.visible-always)', {
            opacity: 0
          }), _defineProperty(_objectSpread2, '.card-icon.clickable-icon', {
            cursor: 'pointer'
          }), _defineProperty(_objectSpread2, "&.".concat(EMBERS_CARD_ROOT_PREFIX, "-locked:hover"), {
            '.card-icon': {
              opacity: 1
            }
          }), _defineProperty(_objectSpread2, "&.".concat(EMBERS_CARD_ROOT_PREFIX, "-editable:hover"), _objectSpread(_objectSpread({}, PROMETHEAN_HEAVY_SHADOW), {}, {
            '.card-icon': {
              cursor: 'pointer',
              opacity: 1
            }
          })), _defineProperty(_objectSpread2, '.card-icon:focus-visible', {
            opacity: 1,
            i: {
              outline: "2px solid ".concat(PROMETHEAN_BLUE)
            },
            span: {
              outline: "2px solid ".concat(PROMETHEAN_BLUE)
            }
          }), _defineProperty(_objectSpread2, '.MuiCardHeader-root', {
            borderBottom: "1px solid ".concat(PROMETHEAN_NEUTRAL_DARK_GREY),
            paddingTop: headerPadding[0],
            paddingRight: headerPadding[1],
            paddingBottom: headerPadding[2],
            paddingLeft: headerPadding[3],
            i: {
              color: PROMETHEAN_TEXT
            },
            '.MuiCardHeader-avatar': {
              marginRight: '8px'
            },
            '.MuiCardHeader-title': _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_SMALL_TEXT_UPPERCASE), {}, {
              color: PROMETHEAN_TEXT_HEADER,
              paddingTop: 1
            })
          }), _defineProperty(_objectSpread2, '.MuiCardContent-root', _defineProperty({
            paddingTop: contentPadding[0],
            paddingRight: contentPadding[1],
            paddingBottom: contentPadding[2],
            paddingLeft: contentPadding[3],
            '&:last-child': {
              paddingBottom: contentPadding[2]
            }
          }, ".".concat(EMBERS_CARD_ROOT_PREFIX, "-content"), {
            '&-header': (_header = {
              position: 'relative',
              '.EmbersTypography-root': {
                color: PROMETHEAN_TEXT_HEADER
              },
              minHeight: 24,
              marginBottom: 24,
              display: 'flex',
              justifyContent: 'space-between'
            }, _defineProperty(_header, ".".concat(EMBERS_CARD_ROOT_PREFIX, "-title"), {
              display: 'flex',
              alignItems: 'center',
              '&-iconTitle': {
                // eslint-disable-next-line quotes
                "[class^='icon-']": {
                  lineHeight: '22px'
                }
              }
            }), _defineProperty(_header, '&-hasIcon', _defineProperty({}, ".".concat(EMBERS_CARD_ROOT_PREFIX, "-title"), {
              paddingRight: 32
            })), _defineProperty(_header, '&-hasRefresh', {
              minHeight: 40,
              marginBottom: 8,
              alignItems: 'center'
            }), _header),
            '&-body': _objectSpread({}, PROMETHEAN_TYPOGRAPHY_BODY),
            '&-loading': {
              padding: '36px 0',
              display: 'flex',
              justifyContent: 'center'
            }
          })), _defineProperty(_objectSpread2, "&.".concat(EMBERS_CARD_ROOT_PREFIX, "-tabbed-card"), {
            '.MuiTabs-root': {
              minHeight: 36,
              borderBottom: "1px solid ".concat(PROMETHEAN_NEUTRAL_DARK_GREY),
              '.MuiTabs-flexContainer': {
                columnGap: '32px'
              },
              '.MuiTabScrollButton-root': {
                paddingBottom: 11
              },
              '.MuiTabs-indicator': {
                background: PROMETHEAN_PURPLE_PLUM,
                height: '4px',
                borderRadius: '1px'
              },
              '.MuiTab-root': _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_SUBTITLE_04), {}, {
                color: PROMETHEAN_TEXT,
                textTransform: 'none',
                padding: '0 8px 8px 8px',
                margin: 0,
                minWidth: 'auto',
                minHeight: 'auto',
                borderRadius: '0',
                '&:after': {
                  content: '" "',
                  height: '4px',
                  borderRadius: '1px',
                  width: 'calc(100% + 16px)',
                  top: '8px',
                  position: 'relative'
                },
                '&:hover:after': {
                  background: PROMETHEAN_NEUTRAL_DARK_PLUM
                },
                '&.Mui-focusVisible': {
                  border: '2px solid ' + PROMETHEAN_BLUE,
                  padding: '0px 6px',
                  height: 24
                }
              })
            }
          }), _objectSpread2))
        }
      }
    }
  });
};